import { textStyles as a } from "../../textStyles.es.js";
import { defineStyle as r, defineStyleConfig as i, keyframes as t } from "@chakra-ui/react";
const e = r({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  borderRadius: "full",
  outlineWidth: "4px",
  outlineStyle: "solid",
  outlineColor: "transparent",
  fontWeight: "medium",
  svg: { boxSize: 4 },
  span: { marginInlineEnd: 0, marginInlineStart: 0 },
  _disabled: { opacity: 0.5, pointerEvents: "none" }
}), n = {
  lg: r(() => ({
    ...a.lg,
    paddingX: "spacing-400",
    minHeight: "size-600",
    minWidth: "size-600",
    gap: "spacing-100",
    '&[data-left-icon="true"]': { paddingLeft: "spacing-300" },
    '&[data-right-icon="true"]': { paddingRight: "spacing-300" }
  })),
  md: r(() => ({
    ...a.md,
    paddingX: "spacing-300",
    minHeight: "size-500",
    minWidth: "size-500",
    gap: "spacing-50",
    '&[data-left-icon="true"]': { paddingLeft: "spacing-200" },
    '&[data-right-icon="true"]': { paddingRight: "spacing-200" }
  })),
  sm: r(() => ({
    ...a.sm,
    paddingX: "spacing-200",
    minHeight: "size-400",
    minWidth: "size-400",
    gap: "spacing-50",
    '&[data-left-icon="true"]': { paddingLeft: "spacing-150" },
    '&[data-right-icon="true"]': { paddingRight: "spacing-150" }
  }))
}, o = {
  primary: r(() => ({
    color: "white",
    backgroundColor: "primary.700",
    _hover: {
      backgroundColor: "primary.500"
    },
    _active: {
      backgroundColor: "primary.900"
    },
    _focusVisible: {
      outlineColor: "primary.100"
    },
    // dark theme
    _dark: {
      color: "primary.700",
      backgroundColor: "primary.0",
      _hover: {
        backgroundColor: "primary.50"
      },
      _active: {
        backgroundColor: "primary.100"
      }
    }
  })),
  secondary: r(() => ({
    color: "white",
    backgroundColor: "secondary.500",
    _hover: {
      backgroundColor: "secondary.600"
    },
    _active: {
      backgroundColor: "secondary.700"
    },
    _focusVisible: {
      outlineColor: "secondary.50"
    }
  })),
  tertiary: r(() => ({
    color: "primary.700",
    backgroundColor: "primary.50",
    _hover: {
      backgroundColor: "primary.100"
    },
    _active: {
      backgroundColor: "primary.200"
    },
    _focusVisible: {
      outlineColor: "primary.100"
    }
  })),
  danger: r(() => ({
    color: "white",
    backgroundColor: "error.500",
    _hover: {
      backgroundColor: "error.600"
    },
    _active: {
      backgroundColor: "error.700"
    },
    _focusVisible: {
      outlineColor: "error.100"
    }
  })),
  transparent: r(() => ({
    color: "primary.700",
    backgroundColor: "transparent",
    _hover: {
      backgroundColor: "primary.50"
    },
    _active: {
      backgroundColor: "primary.100"
    },
    _focusVisible: {
      outlineColor: "primary.100"
    },
    // dark theme
    _dark: {
      color: "primary.0",
      backgroundColor: "transparent",
      _hover: {
        backgroundColor: "primary.500"
      },
      _active: {
        backgroundColor: "primary.400"
      },
      _focusVisible: {
        outlineColor: "primary.100"
      }
    }
  }))
}, c = i({
  baseStyle: e,
  sizes: n,
  variants: o,
  defaultProps: {
    size: "md",
    variant: "primary"
  }
}), s = t`from { width: 0; } to { width: 100%; }`, p = i({
  baseStyle: {
    ...e,
    overflow: "hidden",
    "&[data-error]": {
      pointerEvents: "none",
      userSelect: "none",
      backgroundColor: "error.500"
    },
    "&[data-success]": {
      pointerEvents: "none",
      userSelect: "none",
      backgroundColor: "success.600"
    },
    "&[data-loading]": {
      pointerEvents: "none",
      userSelect: "none",
      "&::before": {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        width: "0%",
        height: "full",
        animation: `${s} 2s linear infinite`,
        backgroundColor: "success.600",
        pointerEvents: "none",
        content: '""'
      }
    },
    "[data-content]": {
      position: "relative",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "spacing-50",
      span: {
        overflow: "hidden",
        display: "block",
        width: "100%",
        opacity: 1,
        transition: "all 250ms linear",
        whiteSpace: "nowrap"
      },
      "span[data-text]": {
        transition: "width 250ms linear"
      },
      "[data-error], [data-loading], [data-success]": {
        opacity: 0,
        maxWidth: 0,
        transition: "all 50ms linear"
      }
    },
    "[data-text]": {
      display: "flex"
    },
    _dark: {
      "&[data-success]": {
        backgroundColor: "success.600"
      }
    }
  },
  sizes: n,
  variants: {
    primary: o.primary,
    secondary: o.secondary,
    tertiary: o.tertiary,
    transparent: o.transparent
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
}), g = i({
  baseStyle: e,
  sizes: n,
  variants: o,
  defaultProps: {
    size: "md",
    variant: "primary"
  }
});
export {
  c as ButtonTheme,
  g as IconButtonTheme,
  p as SmartDataButtonTheme
};
//# sourceMappingURL=Button.es.js.map
